const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "PROJECT_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PROJECT_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "PROJECT_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};